import React from 'react';
import {useDispatch} from "react-redux";
import {openModal} from "@/Store/Slices/ModalSlice";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";

const MultipleHideOnlineCoupon = ({checked}) => {
  const dispatch = useDispatch();

  const handleMultipleAction = () => {
    dispatch(openModal({
      modalType: 'multiple-coupon-modal',
      modalProps: {
        ids: checked,
        url: 'added.coupons.multi.hide',
        text: 'Do you want to hide selected coupons?',
      }
    }));
  }

  return (
    <button onClick={handleMultipleAction} className={'mr-3'} data-tip="Multiple hide coupons" >
      <FontAwesomeIcon
        rotation={180}
        color={'gray'}
        size={'lg'}
        icon={solid('eye-slash')}/>
    </button>
  );
};
export default MultipleHideOnlineCoupon;
